
// Define the SalesNotification type
export interface SalesNotification {
  enabled: boolean;
  // As 12 plataformas do seletor + `custom` (logo enviada pelo usuário).
  // `vegaCheckout` é camelCase — e só ele — por compatibilidade: já está
  // gravado assim em documentos antigos no Mongo e renomear quebraria o ícone
  // de quem já configurou. Os arquivos de logo seguem sempre o slug minúsculo
  // (vegacheckout.webp). A lista viva está em @/lib/sales-notification-platforms.
  platform:
    | 'braip'
    | 'cakto'
    | 'cartpanda'
    | 'digitalguru'
    | 'eduzz'
    | 'hotmart'
    | 'kirvano'
    | 'kiwify'
    | 'monetizze'
    | 'perfectpay'
    | 'ticto'
    | 'vegaCheckout'
    | 'custom';
  showCount: number;
  frequency: number;
  interval: number;
  startDelay?: number;
  animation: 'fade' | 'slideUp' | 'zoom' | 'bounce';
  position: 'top-left' | 'top-center' | 'top-right' | 'middle-left' | 'middle-center' | 'middle-right' | 'bottom-left' | 'bottom-center' | 'bottom-right';
  customMessage?: string;
  messages?: SalesNotificationItem[];
  soundEnabled?: boolean;
  soundVolume?: number;
  customPlatformIcon?: string;
  redirectUrl?: string;
  fontSize?: 'small' | 'medium' | 'large';
  iconSize?: 'small' | 'medium' | 'large';
  showIcon?: boolean;
  loop?: boolean;
  style: {
    bgColor: string;
    textColor: string;
    borderColor?: string;
    borderRadius?: number;
    opacity?: number;
    boxShadow?: boolean;
    padding?: 'small' | 'medium' | 'large';
  };
  // Fields needed for the existing implementation
  type?: 'simulated' | 'webhook';
  template: string;
  names: string[];
  cities: string[];
  product?: string;
  duration: number;
}

// Define the SalesNotificationItem type
export interface SalesNotificationItem {
  id: string;
  message: string;
  timestamp: string;
  location?: string;
  product?: string;
  value?: number;
}

// Export a default sales notification configuration
export const defaultSalesNotification: SalesNotification = {
  enabled: false,
  platform: 'perfectpay',
  showCount: 5,
  frequency: 30,
  interval: 5,
  startDelay: 0,
  animation: 'fade',
  position: 'bottom-right',
  soundEnabled: false,
  soundVolume: 50,
  fontSize: 'medium',
  iconSize: 'medium',
  showIcon: true,
  loop: true,
  style: {
    bgColor: '#ffffff',
    textColor: '#333333',
    borderColor: '#eeeeee',
    borderRadius: 4,
    opacity: 100,
    boxShadow: true,
    padding: 'medium'
  },
  type: 'simulated',
  template: '{Nome} de {Cidade} acabou de comprar {Produto}',
  names: ['Ana', 'João', 'Maria', 'Pedro', 'Lucas'],
  cities: ['São Paulo', 'Rio de Janeiro', 'Belo Horizonte', 'Brasília', 'Salvador'],
  duration: 5
};
